<div class="grid place-content-center">
    <app-icon (click)="onUserSwitchClick()" class="text-black hover:cursor-pointer block" [name]="'mdi:account-switch'" />
</div>
